/* eslint-disable @typescript-eslint/no-explicit-any */
import { useQuery } from "@tanstack/react-query";
import { myHeaders } from "../../config/axios";
import { useState } from "react";
import Swal, { SweetAlertOptions } from "sweetalert2";
import { URL_API } from "../../config/default";

const Preferencias = () => {
  const [form, setForm] = useState<any>({
    currency: "",
    lang: "",
  });
  const { isPending, error } = useQuery({
    queryKey: ["me"],
    queryFn: () => {
      const authorization = new Headers();
      authorization.append("Authorization", myHeaders);
      return fetch(`${URL_API}/auth/me`, {
        method: "GET", // O 'POST', 'PUT', 'DELETE', etc. dependiendo de tu solicitud
        headers: {
          Authorization: myHeaders, // Un ejemplo de header de autenticación
        },
      }).then((res) => res.json());
    },
  });

  if (isPending) return "Loading...";

  if (error) return "Error...";

  const submit = async (formdata: any) => {
    const requestOptions = {
      method: "PUT",
      body: formdata,
      headers: {
        Authorization: myHeaders, // Un ejemplo de header de autenticación
      },
    };

    fetch(`${URL_API}/auth/me`, requestOptions)
      .then(() => {
        const Toast = Swal.mixin({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          didOpen: (toast) => {
            toast.onmouseenter = Swal.stopTimer;
            toast.onmouseleave = Swal.resumeTimer;
          },
        } as SweetAlertOptions);

        return Toast.fire({
          icon: "success",
          title: "Updated in successfully",
        });
      })
      .then((result) => console.log(result))
      .catch((error) => console.error(error));
  };

  // const user = data.data;

  return (
    <div className="m-auto md:w-[80%]">
      <div className="grid grid-cols-2 gap-2">
        <div className="py-4">
          <span className="text-primary font-bold text-xl mb-4 block">
            Preferencias generales
          </span>
          <div className="flex justify-between mb-4">
            <div className="w-full">
              <span className="block font-bold">Idioma preferido</span>
              <select
                name=""
                id="form-lang"
                className="border-0"
                onChange={(e) => {
                  setForm({
                    ...form,
                    lang: e.target.value,
                  });
                }}
              >
                <option value={"ESP"}>Español</option>
                <option value={"ENG"}>Ingles</option>
              </select>
            </div>

            <label className="font-bold">
              <div id="label-lang">Editar</div>
              <button
                className="hidden"
                onClick={() => {
                  if (
                    document
                      .getElementById("form-lang")
                      ?.classList.contains("border-0")
                  ) {
                    document
                      .getElementById("form-lang")
                      ?.classList.remove("border-0");
                      document.getElementById("label-lang")!.innerHTML = "Guardar";
                  } else {
                    document
                      .getElementById("form-lang")
                      ?.classList.add("border-0");
                    document.getElementById("label-lang")!.innerHTML = "Editar";

                    const formData = new FormData();
                    formData.append("_method", "PUT");
                    if (form.lang !== "") formData.append("lang", form.lang);
                    submit(formData);
                  }
                }}
              ></button>
            </label>
          </div>

          <div className="flex justify-between mb-4">
            <div className="w-full">
              <span className="block font-bold">Moneda preferida</span>
              <span className="block">
                Sirve para actualizar el contenido que les en Rumbo Punilla y la
                forma de comunicarnos con vos.
              </span>
              <select
                name=""
                id="form-currency"
                className="border-0"
                onChange={(e) => {
                  setForm({
                    ...form,
                    currency: e.target.value,
                  });
                }}
              >
                <option value={"USD"}>Dolar estadounidense</option>
                <option value={"ARS"}>Peso Argentino</option>
              </select>
            </div>

            <label className="font-bold">
              <div id="label-currency">Editar</div>
              <button
                className="hidden"
                onClick={() => {
                  if (
                    document
                      .getElementById("form-currency")
                      ?.classList.contains("border-0")
                  ) {
                    document
                      .getElementById("form-currency")
                      ?.classList.remove("border-0");
                    document.getElementById("label-currency")!.innerHTML =
                      "Guardar";
                  } else {
                    document
                      .getElementById("form-currency")
                      ?.classList.add("border-0");
                    document.getElementById("label-currency")!.innerHTML =
                      "Editar";

                    const formData = new FormData();
                    formData.append("_method", "PUT");
                    if (form.currency !== "")
                      formData.append("currency", form.currency);
                    submit(formData);
                  }
                }}
              ></button>
            </label>
          </div>

          <div className="flex justify-between mb-4">
            <div>
              <span className="block font-bold">Zona horaria</span>
              <select name="" id="" className="border-0">
                <option value={"America/Buenos_Aires"}>
                  America/Buenos_Aires
                </option>
              </select>
              <span className="block"></span>
            </div>

            <label className="font-bold hidden">
              <div id="label-phone">Editar</div>
              <button className="hidden"></button>
            </label>
          </div>
        </div>
        <div></div>
      </div>
    </div>
  );
};

export default Preferencias;
